var map = {
	"./back_icon.png": "23ca",
	"./camera.png": "dbf6",
	"./close.png": "a262",
	"./decorate.png": "ffb3",
	"./default_img.png": "a7bb",
	"./delete.png": "07f5",
	"./help_icon.png": "dd38",
	"./icon.png": "166e",
	"./ip-arrow.png": "9141",
	"./picture.png": "1b36"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "7721";